export default {
  AVAILABILITIES: `Disponibilités`,
  LIST: {
    TITLE: `Liste des disponibilités`
  },
  FORM: {
    TITLE: ``,
    SUMMARY: ``
  },
  CREATE: `Créer une disponibilité`,
  IMPORT_AVAILABILITIES: `Importer des disponibilités`,
  IN_PROGRESS: `En cours`,
  APPROVAL_REQUIRED: `En attente d'approbation`,
  APPROVE: `Approuver`,
  APPROVED: `Approuvée`,
  CHANGES_REQUESTED: `Changements demandés`,
  STATUS: `Statut`,
  MANAGEMENT: `Gestion`,
  FIRST_COLUMN: ``,
  SECOND_COLUMN: ``,
  VALIDITY: `Validité`,
  VALIDATION_DATE: `Validé le`,
  LAST_UPDATED_DATE: `Modifié le`,
  CREATED_BY_ON: `Créé le {{date}} à <1>{{time}}</1>`,
  LAST_UPDATE_ON: `Dernière modification le {{date}} à <1>{{time}}</1>`,
  STATUS_PHRASE: `<0>{{status}}</0> par <1>{{validatedBy}}</1> le {{date}} à <3>{{time}}</3>`,
  DATE_VALID: `Débute le <0>{{date}}</0>`,
  DATE_EXPIRED: `Expire le <0>{{date}}</0>`,
  TEMPORARY: `Temporaire`,
  NOTES: `Notes :`,
  ATTRIBUTES: `Attributs :`,
  DEPARTMENTS: `Départements :`,
  HIRING_DATA: `Données d'embauche :`,
  REGIONS: `Régions:`,
  NOT_SUBMITED_ENOUGH_IN_ADVANCE: `N'a pas été soumise suffisamment en avance.`,
  AVAILABILITY_IN_PAST_WARNING: `Cette disponibilité commence dans le passé, créer ou modifier une disponibilité pour un employé qui commence dans le passé peut affecter certains rapports.`,
  COMMENT: `Commentaire :`,
  USER_DETAILS: `Détails sur l'utilisateur`,
  DELETE: {
    TITLE: `Supprimer la disponibilité`,
    SUMMARY: `Etes-vous certain de vouloir supprimer la disponibilité ?`,
    PRIMARY_ACTION: `Supprimer la disponibilité`
  },
  form: {
    CREATE: {
      TITLE: `Créer une requête de disponibilité`
    },
    EDIT: {
      TITLE: `Modifier une requête de disponibilité`
    },
    VIEW: {
      TITLE: `Voir une requête de disponibilité`
    },
    DATEVALID: {
      LABEL: `Date de début`,
      DESCRIPTION: `Cette date doit être après celle d'aujourd'hui et ne peut pas être à la même date qu'une autre disponibilité.`,
      TEMPORARY_DESCRIPTION: `Cette date ne doit pas être dans le passé.`
    },
    DATEEXPIRED: {
      LABEL: `Date de fin`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Cette date ne doit pas être dans le passé et doit se trouver au moins une semaine après la date de début.`
    },
    NOTES: {
      LABEL: `Notes`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Entrez des notes ou des informations supplémentaires.`
    },
    TEMPORARY: {
      LABEL: `Fixer une date de fin`,
      DESCRIPTION: ``
    },
    REGULAR: {
      LABEL: `Se répète indéfiniment`,
      DESCRIPTION: `Cette disponibilité sera valide jusqu'au début de la prochaine disponibilité`
    },
    COPY_MODAL: {
      TITLE: `Copier/Coller une journée`,
      PRIMARY_ACTION: `Appliquer`,
      SUMMARY: ``
    },
    USERID: {
      LABEL: `Employé`,
      DESCRIPTION: ``
    },
    APPROVALSTATUS: {
      LABEL: `Statut`,
      DESCRIPTION: ``
    },
    EMPLOYEE_REQUIRED: `Vous devez choisir un employé`,
    NOTES_REQUIRED: `Un commentaire est requis.`,
    START_DATE_AFTER_TODAY: `La date de début doit être après celle d'aujourd'hui.`,
    START_DATE_UNIQUE: `La date de début ne doit pas être la même que celle d'une autre disponibilité.`,
    START_DATE_REQUIRED: `Une date de début est requise.`,
    END_DATE_REQUIRED: `Une date de fin est requise.`,
    END_DATE_AFTER_START: `La date de fin doit être au moins une semaine après la date de début.`,
    SAME_START: `L'employé a déjà une disponibilité existante débutant à cette date.`,
    AVAILABLE_ALL_DAY: `Disponible`,
    UNAVAILABLE_ALL_DAY: `Indisponible`,
    UNAVAILABLE_FROM: `Indisponible de`,
    NOTE_FROM_MANAGER: `Note :`,
    NONE: `Aucun`,
    COPY_TO_FOLLOWING: `Votre disponibilité pour {{ day }} sera appliquée aux jours suivants :`,
    SCHEDULE_TYPES: `Types d'horaire`,
    AVAILABILITY_STARTING_SAME_DAY: `L'employé a déjà une disponibilité existante débutant à cette date.`
  },
  import: {
    TITLE: `Importation de disponibilités`,
    SUMMARY: `Toutes les disponibilités déjà présentes dans l'application et qui sont dans la période d'importation seront supprimées.`,
    EMPLOYEE_NUMBER: `Numéro d'employé`,
    EMPLOYEE_NAME: `Nom de l'employé`,
    STATUS: `Statut`,
    EMPLOYEENUMBER_DESC: `Le numéro de l'employé dans Merinio.`,
    DATEVALID: `Valide le`,
    DATEVALID_DESC: ` La date de début doit être inscrite dans le format suivant : <1>YYYY-MM-DD</1>, par exemple <1>2010-01-30</1> pour le 30 Janvier 2010.`,
    DATEEXPIRED: `Expire le`,
    DATEEXPIRED_DESC: `La date de fin doit être dans le même format que celle de début.`,
    MONDAY: `Lundi`,
    MONDAY_DESC: ` Par défault, l'employé est disponible toute la journée si rien n'est inscrit. Inscrire <1>U</1> pour une indisponibilité toute la journée. Une plage de disponibilité doit être inscrite dans le format <1>AHH:mm-HH:mm</1>, où <1>A08:00-16:00</1> représente une disponibilité entre from 8h et 16h. Utiliser <1>U</1> au lieu de <1>A</1> dans le cas d'une indisponibilité. Pour insérer plusieurs plages horaires, laisser un espace entre chaque code , par exemple <1>A08:00-12:00</1> <1>U12:00-18:00</1>`,
    TUESDAY: `Mardi`,
    TUESDAY_DESC: `Utiliser le même format que pour monday.`,
    WEDNESDAY: `Mercredi`,
    WEDNESDAY_DESC: `Utiliser le même format que pour monday.`,
    THURSDAY: `Jeudi`,
    THURSDAY_DESC: `Utiliser le même format que pour monday.`,
    FRIDAY: `Vendredi`,
    FRIDAY_DESC: `Utiliser le même format que pour monday.`,
    SATURDAY: `Samedi`,
    SATURDAY_DESC: `Utiliser le même format que pour monday.`,
    SUNDAY: `Dimanche`,
    SUNDAY_DESC: `Utiliser le même format que pour monday.`,
    DOWNLOAD_TEMPLATE: `Télécharger un modèle de fichier`,
    TEMPLATE_FILE_NAME: `Importation_disponibilités`,
    MISSING_HEADERS: `Entête manquant : <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Entêtes manquants : <0>{{value}}</0>`,
    AVAILABILITIES_SAVING_FAILED: `Il y a <0>{{count}}</0> disponibilité qui n'a pas été sauvegardée.`,
    AVAILABILITIES_SAVING_FAILED_other: `Il y a <0>{{count}}</0> disponibilités qui n'ont pas été sauvegardées.`,
    AVAILABILITIES_NOT_VALID: `Il y a <0>{{count}}</0> disponibilité invalide.`,
    AVAILABILITIES_NOT_VALID_other: `Il y a <0>{{count}}</0> disponibilités invalides.`,
    ERROR_READING_CSV: `Le fichier importé ne respecte pas le format CSV. Si votre excel est en français, veuillez aller changer le délimiteur par défaut dans vos paramètres.`,
    VALIDATION: `Validation`
  },
  ASK_FOR_CHANGES: `Demander des modifications`,
  ASK_FOR_CHANGES_MODIFY_COMMENT: `Demander des modifications (modifier le commentaire)`,
  REQUEST_CHANGES_MODAL: {
    TITLE: `Demander des changements pour {{fullName}}`,
    SUMMARY: ``,
    COMMENT: {
      LABEL: `Commentaire`,
      PLACEHOLDER: `Entrer un commentaire`,
      DESCRIPTION: `Le commentaire sert à expliquer les raisons de la demande de changement. L'employé verra ce commentaire.`
    }
  },
  csv: {
    AVAILABILITIES_CSV_NAME: `export_disponibilités_{{date}}`,
    FULLNAME: `Nom`,
    EMPLOYEENUMBER: `Numéro d'employé`,
    DEPARTMENTS: `Départements`,
    STATUS: `Statut`,
    DATEVALID: `Date de validité`,
    CREATIONDATE: `Date de création`,
    CREATEDBY: `Créé par`,
    LASTUPDATED: `Dernière modification`,
    LASTUPDATEBY: `Modifié par`,
    VALIDATEDDATE: `Date de validation`,
    VALIDATEDBYID: `Validée par`,
    AVAILABILITY_NAME: `Nom de la disponibilité`,
    COMMENT: `Commentaire`,
    NOTES: `Note`,
    DATEEXPIRED: `Date d'expiration`,
    NOTSUBMITTEDENOUGHINADVANCE: `Pas soumise assez en avance`
  }
}
